<script lang="ts">
	import { GameStatus } from '../types/util/GameStatus.js';
	import HdGameReportGameOfficials from './HDGameReportGameOfficials.svelte';
	import HdGameReportGoals from './HDGameReportGoals.svelte';
	import HdGameReportPenalties from './HDGameReportPenalties.svelte';
	import HdGameReportPlayerStats from './HDGameReportPlayerStats.svelte';
	import HdGameReportTeamStats from './HDGameReportTeamStats.svelte';
	import HdGameReportScore from './HDGameReportScore.svelte';
	import HdGameReportLiveTimeline from './HDGameReportLiveTimeline.svelte';
	import { onMount } from 'svelte';
	import { getGameReport } from '../hockeydata.remote.js';

	export type HDGameReportOptions = [
		'showLiveTimeline'?,
		'showOverview'?,
		'showGameOfficials'?,
		'showTeamStats'?,
		'showPlayerStats'?,
		'showGoals'?,
		'showPenalties'?
	];

	export interface HDGameReportProps {
		gameId?: string;
		title?: string | null;
		options: HDGameReportOptions;
	}

	let { gameId, title, options }: HDGameReportProps = $props();

	function getGame() {
		if (!gameId) {
			return Promise.reject('No game or gameId provided');
		}

		return getGameReport(gameId);
	}

	let gameResponse = $state(await getGame());

	let isLive = $derived.by(() => {
		const gameResult = gameResponse;
		return gameResult.data.gameData.gameStatus === GameStatus.LIVE;
	});

	let interval: NodeJS.Timeout;

	onMount(async () => {
		if (isLive) {
			interval = setInterval(async () => {
				gameResponse = await getGame();
			}, 1000);
		} else {
			clearInterval(interval);
		}
	});
</script>

{#if gameResponse}
	{@const game = gameResponse.data}
	<div class="not-prose flex w-full flex-col gap-3">
		{#if title}
			<div class="text-3xl font-bold tracking-wider uppercase">{title}</div>
		{/if}

		<HdGameReportScore {game} />

		{#if game.gameData.gameStatus >= GameStatus.LIVE}
			{#if options.includes('showLiveTimeline')}
				<HdGameReportLiveTimeline {game} />
			{/if}

			{#if options.includes('showGameOfficials')}
				<HdGameReportGameOfficials {game} />
			{/if}

			{#if options.includes('showTeamStats')}
				<HdGameReportTeamStats {game} />
			{/if}

			{#if options.includes('showGoals')}
				<HdGameReportGoals {game} />
			{/if}

			{#if options.includes('showPenalties')}
				<HdGameReportPenalties {game} />
			{/if}

			{#if options.includes('showPlayerStats')}
				<HdGameReportPlayerStats {game} />
			{/if}
		{/if}
	</div>
{/if}
